import { ReactElement } from 'react';
import { SimpleColumnDiff } from './SimpleColumnDiff';
import { ChangeHistoryColumnDiffProps } from './ChangeHistoryColumnDiff';
import { IDocumentSchemaSettings } from '@tap/data-providers';

const getDiffList = ({ title, oldValue, newValue, columnInfo, slots, slotProps }: ChangeHistoryColumnDiffProps) => {
    const colO = oldValue || {};
    const colN = newValue || {};

    const diffKeys = Object.keys({ ...colO, ...colN })
        .filter(k => JSON.stringify(colO[k]) !== JSON.stringify(colN[k]));

    //TODO
    const schema: IDocumentSchemaSettings = slotProps?.jsonValue?.schemaDict[columnInfo?.jsonProps?.schemaName];

    return diffKeys.map(k => {
        const fieldProps = schema.dataProperties[k];
        const columnProps = {
            title: fieldProps?.name ?? k,
            //TODO: add other props
        }
        return {
            k,
            title: columnProps.title,
            oldValue: colO[k],
            newValue: colN[k],
            columnInfo: columnProps,
            slots,
            slotProps,
        };
    });
}

export const JsonColumnDiff = (props: ChangeHistoryColumnDiffProps): ReactElement => {

    const diffList = getDiffList(props);

    return (
        <>
            {
                diffList.map(jsonField => (
                    <SimpleColumnDiff key={jsonField.k} {...jsonField} />
                ))
            }
        </>

    );
};
